export default {
  sidebar: {
    'switchSide': 'Cambiar lado',
    'showSidebar': 'Mostrar la barra lateral',
    'hideSidebar': 'Ocultar la barra lateral'
  }
}
